import { SkeletonAvatar, SkeletonLine } from "@health/ui";

/**
 * Loading skeleton mirroring the inline ComparisonView — vertical stack of
 * pill-shaped product rows with image thumbnail, title/tagline, and an
 * Explore button.
 */
const ROW_TITLE_WIDTHS = ["lg", "md", "lg"] as const;

function Row({ titleWidth }: { titleWidth: "lg" | "md" }) {
  return (
    <div className="bg-secondary/40 rounded-2xl p-2.5 flex items-center justify-between gap-3">
      <div className="flex items-center gap-5 min-w-0 flex-1">
        <SkeletonAvatar $size="lg" className="rounded-lg" />
        <div className="space-y-1.5 min-w-0 flex-1">
          <SkeletonLine $size="title" $width={titleWidth} />
          <SkeletonLine $size="caption" $width="md" />
        </div>
      </div>
      <SkeletonLine $size="text" $width="sm" className="h-8 rounded-full shrink-0" />
    </div>
  );
}

export function ComparisonSkeleton() {
  return (
    <div className="flex flex-col gap-1.5 w-full">
      {ROW_TITLE_WIDTHS.map((w, i) => (
        <Row key={i} titleWidth={w} />
      ))}
    </div>
  );
}
